export const APP_VERSION = "1.6.0";

export const CHANGELOG = [
  {
    version: "1.6.0",
    date: "2026-08-30",
    changes: [
      "Gastzugang ohne Registrierung – teste SafeBuddy 3 Tage lang im Testmodus.",
      "Neues Modern-Theme mit Farbauswahl und moderner Schriftart.",
      "Mehrsprachige Scan-Seite: Deutsch, Englisch, Französisch, Italienisch, Spanisch, Türkisch.",
      "Support-Chat direkt in der App.",
      "Verbesserter Spam-Schutz beim Scannen deines SafeBuddys.",
      "Zurück-Navigation in allen Bereichen.",
      "Verbesserungen im Einfach-Modus.",
      "Telefonbuch-Integration beim Erstellen eines Buddys.",
      "Demnächst verfügbar: Gruppen-Funktion zum gemeinsamen Verwalten und Freigeben von SafeBuddys.",
    ],
  },
  {
    version: "1.5.0",
    date: "2026-08-26",
    changes: [
      "Neuer Einfach-Modus für die besonders schnelle SafeBuddy-Erstellung.",
      "Kontakt direkt aus dem Telefonbuch übernehmen.",
      "Vollbild-Anzeige als installierte App.",
      "Optimierte Tastatur-Bedienung auf dem Handy.",
      "Spam-Schutz beim Scannen deines SafeBuddys.",
      "PIN-Schutz wird automatisch auf den Tag übertragen.",
    ],
  },
  {
    version: "1.4.0",
    date: "2026-08-26",
    changes: [
      "Übersichtlichere Listen für deine SafeBuddys.",
      "Vereinfachte SafeBuddy-Erstellung.",
      "Neue Vorschau-Funktion: So sehen Finder deinen SafeBuddy.",
      "E-Mail-Adresse direkt in den Einstellungen änderbar.",
      "Allergien-Feld überall entfernt.",
      "Vollständige englische Sprachversion.",
    ],
  },
  {
    version: "1.3.0",
    date: "2026-06-24",
    changes: [
      "Neuer 'Beschriften'-Button bei jedem Buddy auf der Home-Seite zur direkten NFC-Beschriftung via SafeBuddy NFC App.",
      "Automatisches Öffnen der nativen App mit vorausgefüllten Buddy-Daten (Name & URL).",
      "Installations-Hinweis für die SafeBuddy NFC App, falls noch nicht installiert – inkl. QR-Code und Web-NFC-Alternative.",
    ],
  },
  {
    version: "1.2.0",
    date: "2026-08-23",
    changes: [
      "SafeBuddy direkt aus 'Safe Buddies' erstellen – URL wird automatisch kopiert und der NFC-Tag beschrieben.",
      "Finder-Nachrichten: Fundort und optionale Telefonnummer des Finders hinzugefügt.",
      "Ausführliche Schritt-für-Schritt-Anleitung (Android & iOS) für das NFC-Beschreiben.",
      "App zum Home-Bildschirm hinzufügen (PWA).",
      "Versionshistorie in den Einstellungen.",
    ],
  },
  {
    version: "1.1.0",
    date: "2026-08-22",
    changes: [
      "Passwort-Reset per E-Mail, Brute-Force-Schutz und Passwort-Stärke-Anzeige.",
      "Bebilderte Anleitung und Rechtliches-Links auf der Anmeldeseite.",
    ],
  },
  {
    version: "1.0.0",
    date: "2026-08-21",
    changes: [
      "Erste Version: Buddies, NFC/QR, öffentliche Finder-Seite und E-Mail-Benachrichtigungen.",
    ],
  },
];
